
import Gallery from '../Gallery'
import NewBatteryModal from '../NewBattery/components/Modal'

import translations from './CustomizationFunnel.translations'
import ConditionGuidance from './components/ConditionGuidance'
import Introduction from './components/Introduction'
import Proposal from './components/Proposal'
import Step from './components/Step'
import { createCustomizationFunnelData } from './utils/createCustomizationFunnelData'

export default {
  components: {
    ConditionGuidance,
    NewBatteryModal,
    Proposal,
    Gallery,
    Introduction,
    Step,
  },

  props: {
    grade: {
      type: Object,
      required: true,
    },
    pickers: {
      type: Array,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
    funnel() {
      return createCustomizationFunnelData(
        this.grade,
        this.pickers,
        this.$route,
      )
    },
    images() {
      return this.product.images.slice(0, 3)
    },
    selectedOptions() {
      return this.funnel.map(
        ({ options }) =>
          options.find(({ selected }) => !!selected)?.label ?? undefined,
      )
    },
    selectedColorCode() {
      return (
        this.funnel
          .find(({ id }) => id === 'color')
          .options.find(({ selected }) => !!selected)?.color ?? undefined
      )
    },
  },

  methods: {
    nextStep(step) {
      if (!step.autoScrollOnSelection) {
        return
      }

      const currentStepIndex = this.funnel.findIndex(({ id }) => id === step.id)
      const nextStep = this.funnel[currentStepIndex + 1]

      this.$refs[`step-${nextStep.id}`]?.[0]?.$el?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    },
  },
}
